import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function ForWho() {
  const { t } = useI18n();
  return (
    <section className="relative py-24 sm:py-32 border-y border-white/5" data-testid="forwho-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="text-xs tracking-[0.4em] text-[#FF6B00] uppercase">{t.forWho.eyebrow}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 uppercase whitespace-pre-line">
            {t.forWho.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-10">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="glass-card p-8 sm:p-10 lift-card"
            data-testid="forwho-yes"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 rounded-full bg-[#FF6B00]/15 flex items-center justify-center">
                <Check className="text-[#FF6B00]" size={20} strokeWidth={3} />
              </div>
              <h3 className="font-display text-2xl sm:text-3xl tracking-wide uppercase">
                {t.forWho.yesTitle}
              </h3>
            </div>
            <ul className="space-y-4">
              {t.forWho.yes.map((line, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex items-start gap-3 text-zinc-300"
                >
                  <Check size={18} className="text-[#FF6B00] mt-1 shrink-0" strokeWidth={3} />
                  <span>{line}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="glass-card p-8 sm:p-10 lift-card"
            data-testid="forwho-no"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 rounded-full bg-red-500/15 flex items-center justify-center">
                <X className="text-red-500" size={20} strokeWidth={3} />
              </div>
              <h3 className="font-display text-2xl sm:text-3xl tracking-wide uppercase">
                {t.forWho.noTitle}
              </h3>
            </div>
            <ul className="space-y-4">
              {t.forWho.no.map((line, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex items-start gap-3 text-zinc-400"
                >
                  <X size={18} className="text-red-500/80 mt-1 shrink-0" strokeWidth={3} />
                  <span>{line}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
